export default __webpack_public_path__ + "static/404_error-6723f07f6619b94f787da69f58dda9f7.png";